<template>
    <load
        v-if="load"
        color="#f0f8ff"
        mode="table"
        message="Carregando conversa"
        style="height: 100% !important"
    />
    <div style="height: 100%" v-else>
        <div
            class="rounded"
            style="overflow-y: auto; overflow-x: hidden"
            :style="status != 1 ? 'height: 100%;' : 'height: 83%;'"
            id="msn-demanda"
        >
            <MessagesFeed
                :contact="contact"
                :messages="messages"
                :sending="sending"
                :load_message="load_message"
                :writemessage="writemessage"
                :writedemandaname="writedemandaname"
                :type="type"
            />
        </div>
        <MessageComposer
            v-if="status == 1"
            :demanda="demanda"
            @send="sendMessage"
            @completed="$emit('completed')"
            @writing="$emit('writing')"
            @stop-writing="$emit('stop-writing')"
        />
    </div>
</template>

<script>
import MessagesFeed from "./MessagesFeed";
import MessageComposer from "./MessageComposer";

export default {
    props: {
        contact: {
            type: Object,
            default: null,
        },
        messages: {
            type: Array,
            default: () => [],
        },
        demanda: {
            type: Object,
            default: null,
        },
        load: { type: Boolean, default: false },
        sending: { type: Boolean, default: false },
        type: { type: String, default: "contatos" },
        writedemandaname: { type: String, default: "" },
        writemessage: { type: Boolean, default: false },
        status: { type: Number, default: 1 },
    },
    data() {
        return {
            loading: false,
            load_message: false,
        };
    },

    with: {
        load() {
            this.loading = this.load;
        },
    },
    mounted() {
        this.loading = this.load;
    },
    methods: {
        sendMessage(text) {
            this.loading = true;
            this.$emit("sending");

            if (text) {
                setTimeout(() => {
                    document.getElementById("msn-demanda").scroll({
                        top: document.getElementById("msn-demanda")
                            .scrollHeight,
                        left: 0,
                        behavior: "smooth",
                    });
                }, 50);
                this.load_message = true;
                axios
                    .post("api/dashboard/demanda/conversation/send", {
                        contact_id: 99998,
                        type: this.type,
                        text: text,
                    })
                    .then((response) => {
                        this.$emit("new", response.data);
                    })
                    .finally(() => {
                        this.loading = false;
                        this.load_message = false;
                    });
            }
        },
    },
    components: { MessagesFeed, MessageComposer },
};
</script>

<style>
body .direct-chat-info .right > .direct-chat-text {
    background: #00a0a9;
    border-color: #00a0a9;
    color: #fff;
}

.direct-chat-info .right > .direct-chat-text:after,
.direct-chat-info .right > .direct-chat-text:before {
    border-left-color: #00a0a9;
}

.direct-chat-info {
    display: block;
    margin-bottom: 2px;
    font-size: 14px;
}
.conversation {
    /* height: 60vh !important; */
    /* width: -webkit-fill-available; */
    /* background: aliceblue; */
    width: 100%;
    /* overflow: auto;
    overflow-x: hidden; */
}
</style>
